import { useEffect, useRef } from "react";
import PostAvatar from "@/components/ui/PostAvatar";
import Span from "@/components/ui/Span";

const PostCmtInpUserSuggestionBox = ({
  allUsersForTagging,
  handleUserClick,
  handleOutsideClick,
}) => {
  const suggestionBoxRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionBoxRef.current &&
        !suggestionBoxRef.current.contains(event.target)
      ) {
        handleOutsideClick();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleOutsideClick]);

  return (
    <div
      ref={suggestionBoxRef}
      className="absolute left-0 bottom-10 z-30 border rounded-xl bg-white dark:bg-custom_black dark:border-light_primary_label h-40 w-40 overflow-y-auto"
    >
      {allUsersForTagging?.map((user, i) => (
        <div
          className="flex items-center gap-2 py-3 px-3 overflow-hidden hover:bg-black hover:bg-opacity-5 cursor-pointer transition"
          onClick={() => handleUserClick(user)}
          key={i}
        >
          <PostAvatar src={user?.profilePicture} />
          <Span className={"max-w-full truncate"}>{user?.username}</Span>
        </div>
      ))}
    </div>
  );
};

export default PostCmtInpUserSuggestionBox;
